module.exports = __webpack_public_path__ + "img/banner-cabecera.49d042a5.jpg";